<organism-activity-template-search-dumb
    [entityId]="entityId"
    [entityType]="entityType"
    [formTemplates]="formTemplates$ | ngrxPush"
    [formTemplatesIsLoading]="formTemplatesIsLoading$ | ngrxPush"
    [formTemplatesHasError]="formTemplatesHasError$ | ngrxPush"
></organism-activity-template-search-dumb>
